<template>
    <SearchFilter
        id="search-filter"
        v-model="filterValues"
        @input="handleSearch"
        @filterUpdated="handleFilterValuesUpdated"
        :fields="filterFields"
        :header-button="false"
    >
        <template v-slot:header-filters> <KText type="text" name="q" placeholder="Sök material" /></template>
        <template v-slot:quick-filters> </template>
        <template v-slot:fields>
            <KText type="text" label="Namn" name="namn" />
            <KText type="text" label="Artikelnummer" name="artikelnummer" />
            <KText type="text" label="Streckkod 1" name="streckkod1" />
            <KText type="text" label="Streckkod 2" name="streckkod2" />
            <KText type="text" label="Lokal Artikelnummer" name="lokalt_artikelnummer" />
            <KAutocomplete
                label="Leverantör"
                name="leverantor"
                :options="searchLeverantor"
                :onsearch="searchLeverantor"
            />
        </template>
    </SearchFilter>
</template>

<script setup lang="ts">
    import { getConfig, klinikenApi } from "@/api";
    import SearchFilter from "@/components/SearchFilter.vue";
    import { computed, onMounted, ref, watch } from "vue";
    import { Leverantor } from "@/store/modules/leverantorModule";
    import KAutocomplete from "@/components/forms/inputs/Autocomplete/KAutocomplete.vue";

    type LeverantorOption = {
        label: string;
        value: string;
    };

    const emit = defineEmits(["input", "filterUpdated"]);

    const props = defineProps({
        value: {
            type: Object,
            default: () => ({}),
        },
    });

    const leverantor = ref<LeverantorOption[]>([]);

    const filterValues = ref({});

    watch(
        () => props.value,
        (value) => {
            filterValues.value = value;
        },
        {
            immediate: true,
        }
    );

    const searchLeverantor = async (search?: string) => {
        try {
            const { data } = await klinikenApi.get(
                "operation/leverantorer/",
                getConfig({
                    params: {
                        namn: search,
                    },
                })
            );
            return (data.results || []).map((item: Leverantor) => ({
                label: item.namn,
                value: String(item.id),
            }));
        } catch (error) {
            console.error("Kunde inte hämta leverantörer", error);
        }
    };

    const handleSearch = async (data: any) => {
        Object.keys(data).forEach((key) => data[key] === "" && delete data[key]);
        filterValues.value = data;
        emit("input", data);
    };

    const handleFilterValuesUpdated = (data: any) => {
        let filteredData = data;

        emit("filterUpdated", filteredData);
    };

    const filterFields = computed(() => ({
        q: { label: "Sök" },
        namn: { label: "Namn" },
        artikelnummer: { label: "Artikelnummer" },
        streckkod1: { label: "Streckkod 1" },
        streckkod2: { label: "Streckkod 2" },
        lokalt_artikelnummer: { label: "Lokalt artikelnummer" },
        leverantor: { label: "Leverantör", options: leverantor.value as { label: string; value: string }[] },
    }));

    onMounted(async () => {
        await searchLeverantor();
    });
</script>
